export const home = "home";

export const redirectPath = "/error/error-v1";
export const firstPage = "/home";
